//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"Axial",1,0],[0,"CoordinateAxes",1,0],[0,"CoordinatePlane",1,0],[0,"Device",1,0],[0,"Name",1,0],[0,"Radial",1,0],[0,"ReferencePointJunction",1,0],[0,"Rotary1",1,0],[0,"Rotary2",1,0],[0,"Rotary3",1,0],[0,"Rotary4",1,0],[0,"Rotary5",1,0],[0,"Rotary6",1,0],[0,"Setup",1,0],[0,"Type",1,0],[0,"X",1,0],[0,"Y",1,0],[0,"Z",1,0]],[[[],"GetPreferredSolution",{R_:{preferredSolution:''}},0,0],[["preferredSolution"],"SetPreferredSolution",{},1,0],[[],"GetReferencePositionType",{R_:{referencePositionType:''}},0,0],[["referencePositionType"],"SetReferencePositionType",{},1,0],[[],"GetReferencePositionRotary1",{R_:{referencePositionRotary1:''}},0,0],[["referencePositionRotary1"],"SetReferencePositionRotary1",{},1,0],[[],"GetReferencePositionRotary2",{R_:{referencePositionRotary2:''}},0,0],[["referencePositionRotary2"],"SetReferencePositionRotary2",{},1,0],[[],"GetPreferredRangeMinimum",{R_:{preferredRangeMin:''}},0,0],[[],"GetPreferredRangeMaximum",{R_:{preferredRangeMax:''}},0,0]],[]];
SPLM.SIM.KinematicChain = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.KinematicChain";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.KinematicChain.Types = Object.freeze({
    "Unknown" : "Unknown", "Milling" : "Milling", "Turning" : "Turning", "Polar" : "Polar", "Robot" : "Robot"});

SPLM.SIM.KinematicChain.CoordinatePlaneTypes = Object.freeze({
    "Zx" : "Zx", "Xy" : "Xy"});

SPLM.SIM.KinematicChain.PreferredSolutionType = Object.freeze({
    "Invalid" : "Invalid", "Shortest" : "Shortest", "RangeOne" : "RangeOne", "RangeTwo" : "RangeTwo"});

SPLM.SIM.KinematicChain.ReferencePositionType = Object.freeze({
    "Invalid" : "Invalid", "Custom" : "Custom", "Previous" : "Previous"});

export default SPLM;